import { useChatWidgetContext } from 'providers/ChatWidgetProvider';
import { ChangeEvent, FormEvent, useState } from 'react';
import ImageAttachmentPreview from 'components/common/ImageAttachmentPreview';
import classNames from 'classnames';
import { convertFileToAttachment } from 'helpers/utils';
import AttachmentPreview from 'components/common/AttachmentPreview';
import Button from 'components/base/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faImage,
  faPaperPlane,
  faPaperclip
} from '@fortawesome/free-solid-svg-icons';
import { Form } from 'react-bootstrap';
import axios from 'axios';
// 1. IMPORTAMOS TU SERVICIO DE CHAT IGUAL QUE EN EL OTRO COMPONENTE
import { postSendMessage } from 'services/chatService'; 
import { useAuth } from 'providers/AuthProvider';
import { is24hWindowOpen } from 'services/chatService';


const ChatWidgetFooter = () => {
  const [messageText, setMessageText] = useState('');
  const [fileAttachment, setFileAttachment] = useState<File | null>(null);
  const [imageAttachments, setImageAttachments] = useState<File[]>([]);
  const [isSending, setIsSending] = useState(false);
  const API_URL = process.env.REACT_APP_API_URL;
  const { user } = useAuth();
  const miemValue = user?.iniciales || 'Sistema';

  const { sentMessage, conversation } = useChatWidgetContext();

  const windowOpen = is24hWindowOpen(conversation.messages);

  const handleSumbit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    
    if (!messageText && !fileAttachment && imageAttachments.length === 0) return;
    if (isSending) return;

    setIsSending(true);

    // Extraemos las variables tal como lo hace tu ChatContentFooter
    // NOTA: Revisa el comentario más abajo sobre el 'celular'
    //const recipient = (conversation.user as any).celular; 
    const recipient = conversation.user.celular; // <-- Asegúrate de que 'celular' esté en tu objeto 'user'
    console.log("Enviando a número:", recipient);

    const personaId = conversation.id; // En el paso anterior mapeamos esto como proc.ACTOR
    const conversationId = conversation.id; 

if (!recipient) {
      console.error("No se puede enviar: El usuario no tiene un número de celular configurado.");
      setIsSending(false); // Liberamos el botón
      return; // Detenemos la ejecución aquí mismo
    }

    const textToSend = messageText;
    const imagesToSend = [...imageAttachments];
    const fileToSend = fileAttachment;

    console.log("Enviando a número:", recipient);
    // 1. UI Local: Actualizamos la vista de React inmediatamente (como hace tu chatDispatch)
    sentMessage({
      message: textToSend,
      attachments: {
        images: imagesToSend.map(img => URL.createObjectURL(img)),
        file: fileToSend ? convertFileToAttachment(fileToSend) : undefined
      }
    });

    // 2. Limpiamos los inputs
    setMessageText('');
    setImageAttachments([]);
    setFileAttachment(null);

    try {
      // 3. ENVIAR TEXTO usando tu servicio existente
      if (textToSend) {
        await postSendMessage(recipient, textToSend, miemValue); // <-- Enviamos el "miem" al backend
      }

      // 4. ENVIAR IMÁGENES
      if (imagesToSend.length > 0) {
        for (const img of imagesToSend) {
          const formData = new FormData();
          formData.append('file', img);
          formData.append('phone', String(recipient));
          formData.append('type', 'image');
          formData.append('persona_id', String(personaId));
          formData.append('conversacion_id', String(conversationId));
          await axios.post(`${API_URL}/whatsapps/send-media`, formData);
        }
      }

      // 5. ENVIAR DOCUMENTO
      if (fileToSend) {
        const formData = new FormData();
        formData.append('file', fileToSend);
        formData.append('phone', String(recipient));
        formData.append('type', 'document');
        formData.append('persona_id', String(personaId));
        formData.append('conversacion_id', String(conversationId));
        await axios.post(`${API_URL}/whatsapps/send-media`, formData);
      }

    } catch (error) {
      console.error("Error enviando el mensaje:", error);
    } finally {
      setIsSending(false);
    }
  };

  return (
    <form onSubmit={handleSumbit}>
      {fileAttachment && (
        <div className={classNames({ 'mb-2': fileAttachment })}>
          <AttachmentPreview
            attachment={convertFileToAttachment(fileAttachment)}
            size="xl"
            handleRemove={() => setFileAttachment(null)}
          />
        </div>
      )}

      {imageAttachments && (
        <div
          className={classNames('d-flex gap-2', {
            'mb-2': imageAttachments.length
          })}
        >
          {imageAttachments.map((attachment, index) => (
            <ImageAttachmentPreview
              key={index}
              image={URL.createObjectURL(attachment)}
              handleClose={() => {
                setImageAttachments(
                  imageAttachments.filter((_, i) => index !== i)
                );
              }}
            />
          ))}
        </div>
      )}

      <div className="d-flex align-items-center gap-2">
        <div className="d-flex align-items-center flex-1 gap-3 border rounded-pill px-4">
          <Form.Control
            className="outline-none border-0 flex-1 fs--1 px-0"
            type="text"
            value={messageText}
            onChange={e => setMessageText(e.target.value)}
            placeholder={windowOpen ? "Escribe un mensaje..." : "Ventana de 24h cerrada"}
            disabled={!windowOpen || isSending} // 🚀 AQUÍ SE DESHABILITA LA ESCRITURA
          />
          <div>
            <Button className="p-0">
              <label
                className="text-body-quaternary fs-9 cursor-pointer"
                htmlFor="widgetImages"
              >
                <FontAwesomeIcon icon={faImage} transform="down-1" />
              </label>
            </Button>

            <Form.Control
              className="d-none"
              type="file"
              accept="image/*"
              id="widgetImages"
              multiple
              onChange={({
                target: { files }
              }: ChangeEvent<HTMLInputElement>) =>
                files && setImageAttachments(Array.from(files))
              }
            />
          </div>
          <div>
            <Button className="p-0">
              <label
                className="text-body-quaternary fs-9 cursor-pointer"
                htmlFor="widgetAttachments"
              >
                <FontAwesomeIcon icon={faPaperclip} transform="down-1" />
              </label>
            </Button>
            <Form.Control
              className="d-none"
              type="file"
              id="widgetAttachments"
              accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.zip,.rar"
              onChange={({
                target: { files }
              }: ChangeEvent<HTMLInputElement>) => {
                files && setFileAttachment(files[0]);
              }}
            />
          </div>
        </div>

        <Button className="p-0 border-0 send-btn" type="submit" disabled={!windowOpen || isSending}>
          <FontAwesomeIcon icon={faPaperPlane} className="fs-9" />
        </Button>


      </div>
    </form>
  );
};

export default ChatWidgetFooter;